import { useEffect, useState } from "react";

const links = [
  { href: "#trending", label: "今日热榜" },
  { href: "#feed", label: "瓜田上新" },
  { href: "#feature", label: "深度大瓜" },
  { href: "#reviews", label: "网友辣评" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="wrap flex h-16 items-center justify-between gap-4" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap" onClick={() => setOpen(false)}>
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-music-2-line text-lg"></i>
          </span>
          <span className="font-display text-lg font-black tracking-wide text-foreground-950">
            吃瓜<span className="text-primary-600">五一</span>
          </span>
        </a>

        <ul className="hidden items-center gap-7 lg:flex">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className="whitespace-nowrap text-sm font-medium text-foreground-700 transition hover:text-primary-600"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-bold text-foreground-950 transition hover:bg-accent-600 sm:inline-flex"
          >
            订阅早报
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50/90 text-foreground-800 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <ul className="flex flex-col gap-1">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition hover:bg-background-100 hover:text-primary-600"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="mt-2 block rounded-md bg-accent-500 px-3 py-2.5 text-center text-sm font-bold text-foreground-950"
              >
                订阅热瓜早报
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}